import { Injectable } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { CourseActivity } from '@models/course/course-activity.model';
import { CourseMemberAnswer } from '@models/course/member/course-member-answer.model';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class CourseActivityService {
  constructor() {}

  isCompletedActivityFromAnswers(
    activity: CourseActivity,
    answers: CourseMemberAnswer[],
  ): boolean {
    const answer = this.getAnswer(activity, answers);

    return this.isCompletedActivityFromAnswer(answer);
  }

  isCompletedActivityFromAnswer(answer: CourseMemberAnswer): boolean {
    if (answer?.result?.completion) {
      return true;
    }

    return false;
  }

  isStartedActivityFromAnswer(answer: CourseMemberAnswer): boolean {
    if (answer?.result && !answer.result.completion) {
      return true;
    }

    return false;
  }

  isSuccessfulActivityFromAnswers(
    activity: CourseActivity,
    answers: CourseMemberAnswer[],
  ): boolean {
    const answer = this.getAnswer(activity, answers);

    return this.isSuccessfulActivityFromAnswer(answer);
  }

  isSuccessfulActivityFromAnswer(answer: CourseMemberAnswer): boolean {
    return !!answer?.result?.success;
  }

  getScoreFromAnswers(
    activity: CourseActivity,
    answers: CourseMemberAnswer[],
  ): string {
    const answer = this.getAnswer(activity, answers);

    return this.getScoreFromAnswer(answer);
  }

  getScoreFromAnswer(answer: CourseMemberAnswer): string {
    if (typeof answer?.result?.score === 'number') {
      let score = (answer.result.score * 100) / answer.result.maxScore;
      if (score < 0) {
        score = 0;
      }
      return score.toFixed(0) + '%';
    }

    return '';
  }

  isNonNeutralActivityFromAnswers(
    activity: CourseActivity,
    answers: CourseMemberAnswer[],
  ): boolean {
    const answer = this.getAnswer(activity, answers);

    return this.isNonNeutralActivityFromAnswer(answer);
  }

  isNonNeutralActivityFromAnswer(answer: CourseMemberAnswer): boolean {
    return answer?.result?.maxScore > -1;
  }

  getAnswer(activity: CourseActivity, answers: CourseMemberAnswer[]): any {
    return answers
      .map(a => ({ ...JSON.parse(a.content), skipped: a.skipped }))
      .find(a => a.activityId === activity.id);
  }
}
